import axios from "axios";
import Vue from "vue";
import Vuex from "vuex";


Vue.use(Vuex);

const state = {
    ShortLinks: [],
    ShortLinksUsers: [],
};

const mutations = {
    setShortLink(state, items) {
        state.ShortLinks = items;

       // localStorage.setItem("shortlink", JSON.stringify(state.ShortLinks));

    },
    setShortLinkUser(state, items){
        state.ShortLinksUsers = items;
      //  localStorage.setItem("shortlink_user", JSON.stringify(state.ShortLinksUsers));

    },
    add_shortlink_user(state,item){
        state.ShortLinksUsers.push(item);

     //   localStorage.setItem("shortlink_user", JSON.stringify(state.ShortLinksUsers));
    },
    add_short_link(state, item) {
        if (!item.longUrl) {
            console.error("لینک نامعتبر است");
            return;
        }
        state.ShortLinks.push(item);
      //  localStorage.setItem("shortlink", JSON.stringify(state.ShortLinks));
    },
    remove_shortlink_user(state,item){
        state.ShortLinksUsers = state.ShortLinksUsers.filter(p=>p.id!==item.id);
     //   localStorage.setItem('shortlink_user',JSON/stringify(state.ShortLinksUsers));
    },
    remove_short_link(state, item) {
        state.ShortLinks = state.ShortLinks.filter(p => p.id !== item.id);
      //  localStorage.setItem('shortlink', JSON.stringify(state.ShortLinks));
    }, 
    clear_shortlink_user(state){
        state.ShortLinksUsers = [];
     //   localStorage.removeItem('shortlink_user');
    },
    clear_short_link(state) {
        state.ShortLinks = [];
     //   localStorage.removeItem('shortlink');
    },
    active_short_link(state,item){
        let s = state.ShortLinks.findIndex(p=>p.id===item.id);
        state.ShortLinks[s] = item;
     //   localStorage.setItem('shortlink', JSON.stringify(state.ShortLinks));
    },
    edit_short_link(state,item){
        let s = state.ShortLinks.findIndex(p=>p.id===item.id);
        state.ShortLinks[s] = item;
     //   localStorage.setItem('shortlink', JSON.stringify(state.ShortLinks));
    } 

};

const getters = {
    ShortLinks: (state) => state.ShortLinks,
    ShortLinksUsers: (state) => state.ShortLinksUsers
};  

const actions = {
   
    // async setShortLinks({ commit }, items) {
    //     try{

    //         const items = await GetLinks();
    //         commit('setShortLink',items)

    //     }catch(err){
    //         console.error("خطا در دریافت لینک‌ها:", err);
    //     }
    // },
    async addShortLink({ commit }, item) {
        commit('add_short_link', item);        
    },
    async removeShortLink({ commit }, item) {
        commit('remove_short_link', item);
    },
    async clearShortLink({ commit }) {
        commit('clear_short_link');
    },
    async loadShortLink({ commit }) {
        try{
            const items = await GetLinks();
            commit('setShortLink',items);

        }catch(err){
            console.error("خطا در دریافت لینک‌ها:", err);
        }
        // let items = localStorage.getItem('shortlink');
        // let shortlink_user = localStorage.getItem('shortlink_user');
        // try {
        //     items = (items && items !== "undefined") ? JSON.parse(items) : [];
        //     shortlink_user = (shortlink_user && shortlink_user !== "undefined") ? JSON.parse(shortlink_user): [];
        // } catch (error) {
        //     console.error("خطا در خواندن داده‌ها از localStorage", error);
        //     items = [];
        //     shortlink_user=[];
        // }
        // commit('setShortLinkUser',shortlink_user);
        // commit('setShortLink', items);
    },
    async addShortLinkUser({commit}, item){
        commit('add_shortlink_user',item)
    },
    async removeShortLinksUsers({commit},item){
        commit('remove_shortlink_user',item)
    },
    async clearShortLinksUsers({commit}){
        commit('clear_shortlik_user')
    }
};

export default {
    namespace: true,
    state,
    getters,
    mutations,
    actions
};
